const moment = require('moment');

/*@ngInject*/
const ConfigurationActionsUtil = function ($rootScope, $state, $uibModal, $window, $q, modalUtil, loadingBarHandler, coreConstant, configurationMediator, notificationPopupUtil, formViewerModel, fileExportUtil, xmlUtil, sectionTemplateActionsUtil, uiFormTemplateRepository, formViewerConstant, uiPerformanceLoggerConstant, formTemplateType, formTemplateStatus, localization, uiFormTemplateModel, fieldType, umStudioConstant, productTemplateEditorRepository, productTemplateEditorModel, notificationEmailTemplateRepository, notificationPopupTemplateRepository, navigationStateModel) {

    localization.getTranslations().then((translations) => {

        this.showFormReferences = function (translationRoot, uiFormTemplateId, formTemplateUniqueName, showConfirmationButtons) {
            return configurationMediator.getFormReferences(uiFormTemplateId).then(function (formTemplateReferences) {
                return modalUtil.openFormReferencesModal(translationRoot, formTemplateReferences, formTemplateUniqueName, showConfirmationButtons);
            });
        };

        this.showFormTemplateSettings = function (uiFormTemplateId) {
            const instance = $uibModal.open({
                templateUrl: '/configuration/formTemplateSettings/formTemplateSettingsTemplate.tpl.html',
                controller: 'formTemplateSettingsController',
                windowClass: 'formTemplateSettingsModal',
                resolve: {
                    options: {
                        formTemplateId: uiFormTemplateId
                    }
                }
            });

            return instance.result;
        };

        this.saveUiFormTemplate = function (uiFormTemplateId, saveAs) {
            let uiFormTemplate;

            const formStructure = formViewerModel.getFormStructure(uiFormTemplateId);

            if (formStructure) {
                this.populateUiFormTemplateModel(uiFormTemplateId);
                uiFormTemplate = formStructure.uiFormTemplate;
            } else {
                uiFormTemplate = uiFormTemplateModel.getUiFormTemplate();
            }
            loadingBarHandler.showLoadingBar('formEditor.saveUiFormTemplate.loadingBar');
            if (_.isNil(uiFormTemplate.id) || saveAs) {
                uiFormTemplateRepository.createFormTemplate(uiFormTemplate).then((uiFormTemplate) => {
                    loadingBarHandler.hideLoadingBar();
                    this.handleUiFormTemplateSave(uiFormTemplate, true);
                    navigationStateModel.updateViewStateData('configuration.formTemplateBrowser', uiFormTemplate.id);
                });
            } else {
                uiFormTemplateRepository.updateFormTemplate(uiFormTemplate, uiFormTemplate.id).then((uiFormTemplate) => {
                    loadingBarHandler.hideLoadingBar();
                    this.handleUiFormTemplateSave(uiFormTemplate, true);
                });
            }
        };

        this.handleUiFormTemplateSave = function (uiFormTemplate, doTransition) {
            return new Promise(function (resolve, reject) {

                if (uiFormTemplate.formTemplate.valid === false) {
                    let type = '';

                    const config = {
                            confirmActionButtonLabel: _.get(translations, 'formEditor.saveUiFormTemplate.confirmationConfirmActionButtonLabel'),
                            summary: '',
                            title: _.get(translations, 'formEditor.saveUiFormTemplate.confirmationTitle'),
                            errors: []
                        },
                        formTemplateUniqueName = uiFormTemplate.formTemplate.uniqueName,
                        formTemplateVersionNumber = uiFormTemplate.formTemplate.version,
                        failingErrors = _.intersection(uiFormTemplate.formTemplate.validationErrors, ['duplicateUniqueNameVersionCombination', 'emptyDisplayName']);

                    _.each(Object.keys(formTemplateType), function (key) {
                        if (formTemplateType[key] === uiFormTemplate.formTemplate.type) {
                            type = _.startCase(key);
                        }
                    });
                    if (uiFormTemplate.formTemplate.status !== formTemplateStatus.DRAFT || failingErrors.length > 0) {
                        config.summary = _.get(translations, 'formEditor.saveUiFormTemplate.saveFailedWithErrors');
                        $rootScope.$broadcast(formViewerConstant.event.FORM_TEMPLATE_INVALIDATED);
                        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED, uiFormTemplate);
                        if (doTransition) {
                            $state.transitionTo($state.current, {uiFormTemplateId: uiFormTemplate.id},
                                {
                                    reload: false, inherit: false, notify: true
                                });
                        }
                        reject();
                    } else {
                        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED, uiFormTemplate);
                        config.summary = _.get(translations, 'formEditor.saveUiFormTemplate.saveSucceededWithErrors');
                        if (doTransition) {
                            $state.transitionTo($state.current, {uiFormTemplateId: uiFormTemplate.id},
                                {
                                    reload: true, inherit: false, notify: true
                                });
                        }
                        resolve();
                    }
                    _.each(uiFormTemplate.formTemplate.validationErrors, function (validationErrorCode) {
                        let errorText = _.replace(_.get(translations, 'formEditor.saveUiFormTemplate.' + validationErrorCode), '{formTemplateUniqueName}', formTemplateUniqueName);
                        errorText = _.replace(errorText, '{formTemplateVersionNumber}', formTemplateVersionNumber);
                        errorText = _.replace(errorText, '{formTemplateType}', type);
                        config.errors.push(errorText);
                    });

                    $uibModal.open({
                        templateUrl: '/configuration/formEditor/header/errorModal/formTemplateErrorModal.tpl.html',
                        controller: 'formTemplateErrorModalController',
                        windowClass: 'formTemplateErrorModal',
                        resolve: {
                            options: function () {
                                return config;
                            }
                        }
                    });
                } else {
                    $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED, uiFormTemplate);
                    if (doTransition) {
                        $state.transitionTo($state.current, {uiFormTemplateId: uiFormTemplate.id},
                            {
                                reload: true, inherit: false, notify: true
                            });
                    }
                    $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'formEditor.saveUiFormTemplate.saveSucceeded'));
                    resolve();
                }
            });
        };

        //Populates the formStructures uiFormTemplate object based the section/row/field info in the model
        this.populateUiFormTemplateModel = function (uiFormTemplateId) {
            const formStructure = formViewerModel.getFormStructure(uiFormTemplateId),
                uiFormTemplate = formStructure.uiFormTemplate;

            function populateFields(sourceFieldList, rowId) {
                let fieldList = [];

                _.each(sourceFieldList, function (uiField, fieldOrder) {
                    const isUnsavedField = uiField.id === -1;

                    uiField.ordering = fieldOrder;

                    if (isUnsavedField) {
                        if (rowId) {
                            uiField.rowId = rowId;
                        } else {
                            delete uiField.rowId;
                        }

                        delete uiField.id;
                        delete uiField.fieldTemplate.id;
                        delete uiField.fieldTemplate.formTemplateId;
                    }

                    fieldList.push(uiField);
                });

                return fieldList;
            }

            uiFormTemplate.sections = [];

            _.each(formStructure.sectionList, function (section, sectionOrder) {
                const isUnsavedSection = _.get(section, 'sectionTemplate.id') === -1;

                uiFormTemplate.sections.push(section.sectionTemplate);
                section.sectionTemplate.ordering = sectionOrder;
                section.sectionTemplate.rows = [];

                if (isUnsavedSection) {
                    delete section.sectionTemplate.id;
                }

                _.each(section.rowList, function (row, rowOrder) {
                    let uiFieldList;

                    const isUnsavedRow = _.get(row, 'rowTemplate.id') === -1;

                    if (isUnsavedRow) {
                        delete row.rowTemplate.id;
                    }

                    row.rowTemplate.fields = [];

                    if (row.repeating) {
                        uiFieldList = _.map(row.rowList[0].fieldStructureList, function (fieldStructure) {
                            if (fieldStructure.uiField.fieldTemplate.type === fieldType.ROWREPEATER) {
                                return row.rowList[0].rowTemplate.repeaterField;
                            } else {
                                return fieldStructure.uiField;
                            }
                        });
                        row.rowTemplate = {
                            id: row.rowTemplate.id,
                            sectionId: section.sectionTemplate.id,
                            ordering: rowOrder,
                            repeaterField: row.rowTemplate.repeaterField,
                            fields: populateFields(uiFieldList, row.rowTemplate.id),
                            repeatable: true,
                            rowRepeatable: true,
                            staticLayout: false
                        };
                    } else {
                        uiFieldList = _.map(row.fieldStructureList, 'uiField');
                        row.rowTemplate = {
                            id: row.rowTemplate.id,
                            sectionId: section.sectionTemplate.id,
                            ordering: rowOrder,
                            fields: populateFields(uiFieldList, row.rowTemplate.id),
                            repeatable: false,
                            repeaterField: null,
                            rowRepeatable: false,
                            staticLayout: false
                        };
                    }

                    section.sectionTemplate.rows.push(row.rowTemplate);
                });
            });
        };


        this.deleteFormTemplate = function (uiFormTemplateId, formTemplateUniqueName, translations, loadingBarKey) {
            configurationMediator.getFormReferences(uiFormTemplateId).then(function (formTemplateReferences) {
                modalUtil.openFormReferencesModal('formReferencesDelete', formTemplateReferences, formTemplateUniqueName, /*showConfirmationButtons*/true).then(function () {
                    loadingBarHandler.showLoadingBar(loadingBarKey);
                    configurationMediator.deleteUIFormTemplate(uiFormTemplateId).then(function () {
                        const message = _.get(translations, 'deleteFormTemplate.resultMessage');

                        $state.go('configuration.formTemplateBrowser');

                        $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, message);
                    }).finally(function () {
                        loadingBarHandler.hideLoadingBar();
                    });
                });
            });
        };

        this.markFormTemplateInProduction = function (uiFormTemplateId, translationRoot, translations) {
            function handleClose() {
                return configurationMediator.markFormTemplateInProduction(uiFormTemplateId).then(function () {
                    const message = _.get(translations, 'markFormTemplateInProduction.resultMessage');

                    // Temporary to refresh the "Status" UI in the header, remove once UMS-19178 is implemented.
                    $state.reload();

                    $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, message);
                });
            }

            return modalUtil.showConfirmationModal(
                /*submissionId*/null,
                /*quoteId*/null,
                /*notificationName*/null,
                translationRoot,
                /*logAction*/null,
                /*hideLoadingBar*/false,
                handleClose);
        };

        this.importFormTemplates = function (file, translations) {

            function handleClose() {
                loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'importFormTemplates.loadingBar'));
                return configurationMediator.importFormTemplates(file).then(function (result) {
                    let config,
                        errorSummary,
                        failedReasons = '';

                    const results = xmlUtil.parseString(result),
                        successfulImports = parseInt(results['successCount']),
                        failedImports = parseInt(results['failureCount']),
                        failureDetails = results['failureDetails'];

                    if (failedImports === 0) {
                        loadingBarHandler.concludeNotificationLoadingBar(_.replace(_.get(translations, 'importFormTemplates.' + (successfulImports === 1 ? 'successMessageSingular' : 'successMessagePlural')), '{0}', successfulImports));
                    } else {
                        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);

                        errorSummary = _.get(translations, 'importFormTemplates.errorModal.summary');
                        errorSummary = _.replace(errorSummary, '{0}', successfulImports);
                        errorSummary = _.replace(errorSummary, '{1}', failedImports);

                        if (_.isArray(failureDetails)) {
                            _.each(failureDetails, function (detail) {
                                failedReasons += detail.formTemplateUniqueName + '(' + detail.formTemplateVersion + ')\n' + detail.errorMessage + '\n\n';
                            });
                        } else {
                            failedReasons += failureDetails.formTemplateUniqueName + '(' + failureDetails.formTemplateVersion + ')\n' + failureDetails.errorMessage + '\n\n';
                        }

                        errorSummary = _.replace(errorSummary, '{2}', failedReasons);

                        config = {
                            confirmActionButtonLabel: _.get(translations, 'importFormTemplates.errorModal.confirmActionButtonLabel'),
                            summary: errorSummary,
                            title: _.get(translations, 'importFormTemplates.errorModal.title')
                        };

                        modalUtil.showGenericConfirm(config);
                    }
                }, function () {
                    // On Error
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                });
            }

            return modalUtil.showConfirmationModal(
                /*submissionId*/null,
                /*quoteId*/null,
                /*notificationName*/null,
                'formTemplateBrowser.importFormTemplates',
                /*logAction*/null,
                /*hideLoadingBar*/true,
                handleClose);
        };

        this.exportFormTemplate = function (formTemplateId, loadingBarKey) {
            const selectedFormTemplate = {
                    formTemplateId: formTemplateId
                },
                selectedFormTemplates = [selectedFormTemplate];

            return this.exportFormTemplates(selectedFormTemplates, null, null, loadingBarKey);
        };

        this.exportFormTemplates = function (selectedFormTemplates, filterUri, excludedFormTemplates, loadingBarKey) {
            let selectedFormTemplateIds = [],
                excludedFormTemplateIds = [];

            _.each(selectedFormTemplates, function (selectedFormTemplate) {
                selectedFormTemplateIds.push(selectedFormTemplate.formTemplateId);
            });

            _.each(excludedFormTemplates, function (excludedFormTemplate) {
                excludedFormTemplateIds.push(excludedFormTemplate.formTemplateId);
            });

            function saveFile(fileResult) {
                const filename = 'FormTemplates_' + moment().format('YYYYMMDDhhmmss') + '.dbinit';

                loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.exportFormTemplates.successMessage'));

                fileExportUtil.saveAs(fileResult, 'application/xml', filename);
            }

            loadingBarHandler.showNotificationLoadingBar(_.get(translations, loadingBarKey));
            if (!_.isEmpty(selectedFormTemplateIds)) {
                return configurationMediator.exportFormTemplates(selectedFormTemplateIds).then(function (result) {
                    saveFile(result);
                }, function () {
                    // On Error
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                });
            } else {
                return configurationMediator.exportFormTemplatesByFilterUri(filterUri, excludedFormTemplateIds).then(function (result) {
                    saveFile(result);
                }, function () {
                    // On Error
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                });
            }
        };

        this.exportDataSet = function (dataSetName) {
            const dataSet = {
                name: dataSetName
            };

            return this.exportDataSets([dataSet]);
        };

        this.exportDataSets = function (selectedDataSets, filterUri, excludedDataSets) {
            let selectedDataSetNames = [],
                excludedDataSetNames = [];

            _.each(selectedDataSets, function (selectedDataSet) {
                selectedDataSetNames.push(selectedDataSet.name);
            });

            _.each(excludedDataSets, function (excludedDataSet) {
                excludedDataSetNames.push(excludedDataSet.name);
            });

            function saveFile(fileResult) {
                const filename = 'Data Sets_' + moment().format('YYYYMMDDhhmmss') + '.dbinit';

                loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'dataSetBrowser.export.successMessage'));

                fileExportUtil.saveAs(fileResult, 'application/xml', filename);
            }

            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'dataSetBrowser.export.loadingBar'));
            if (!_.isEmpty(selectedDataSetNames)) {
                return configurationMediator.exportDataSetsByName(selectedDataSetNames).then(function (result) {
                    saveFile(result);
                }, function () {
                    // On Error
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                });
            } else {
                return configurationMediator.exportDataSetsByNameWithFilter(filterUri, excludedDataSetNames).then(function (result) {
                    saveFile(result);
                }, function () {
                    // On Error
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                });
            }
        };

        this.reloadFormRules = function () {
            const modalInstance = $uibModal.open({
                templateUrl: '/configuration/reloadRulesModal/reloadRulesModal.tpl.html',
                controller: 'reloadRulesModalController',
                windowClass: 'reloadRulesModal',
                resolve: {
                    options: {
                        localizationRoot: 'formTemplateBrowser.reloadFormRules'
                    }
                }
            });

            modalInstance.result.then(function (response) {
                const logAction = uiPerformanceLoggerConstant.RELOAD_FORM_RULES;

                function onSuccess() {
                    loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.reloadFormRules.successMessage'));
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
                }

                function onError() {
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
                }

                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction);
                loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.reloadFormRules.loadingBar'));
                configurationMediator.reloadFormRules(response.validate).then(onSuccess, onError);
            });
        };

        this.reloadFieldRules = function () {
            const modalInstance = $uibModal.open({
                templateUrl: '/configuration/reloadRulesModal/reloadRulesModal.tpl.html',
                controller: 'reloadRulesModalController',
                windowClass: 'reloadRulesModal',
                resolve: {
                    options: function () {
                        return {
                            localizationRoot: 'formTemplateBrowser.reloadFieldRules'
                        };
                    }
                }
            });
            modalInstance.result.then(function (response) {
                const logAction = uiPerformanceLoggerConstant.RELOAD_FORM_RULES;

                function onSuccess() {
                    loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.reloadFieldRules.successMessage'));
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
                }

                function onError() {
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
                }

                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction);
                loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.reloadFieldRules.loadingBar'));
                configurationMediator.reloadFieldRules(response.validate).then(onSuccess, onError);
            });
        };

        this.reloadSectionTemplateRules = function () {
            const modalInstance = $uibModal.open({
                templateUrl: '/configuration/reloadRulesModal/reloadRulesModal.tpl.html',
                controller: 'reloadRulesModalController',
                windowClass: 'reloadRulesModal',
                resolve: {
                    options: function () {
                        return {
                            localizationRoot: 'sectionTemplateBrowser.reloadRules'
                        };
                    }
                }
            });
            modalInstance.result.then(function (response) {
                const logAction = uiPerformanceLoggerConstant.RELOAD_SECTION_TEMPLATE_RULES;

                function onSuccess() {
                    loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'sectionTemplateBrowser.reloadRules.successMessage'));
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.SUCCESS);
                }

                function onError() {
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, logAction, coreConstant.uiPeformanceLogger.FAIL);
                }

                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, logAction);
                loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'sectionTemplateBrowser.reloadRules.loadingBar'));
                sectionTemplateActionsUtil.reloadSectionTemplateRules(response.validate).then(onSuccess, onError);
            });
        };

        this.publishFormTemplates = function(loadingBarKey, selectedFormTemplates, filterUri, excludedFormTemplates){
            let selectedFormTemplateIds = [],
                excludedFormTemplateIds = [],
                deferred = $q.defer();

            _.each(selectedFormTemplates, function (selectedFormTemplate) {
                selectedFormTemplateIds.push(selectedFormTemplate.id);
            });

            _.each(excludedFormTemplates, function (excludedFormTemplate) {
                excludedFormTemplateIds.push(excludedFormTemplate.id);
            });

            loadingBarHandler.showLoadingBar(loadingBarKey);
            if (!_.isEmpty(selectedFormTemplateIds)) {
                configurationMediator.publishFormTemplates(selectedFormTemplateIds).then(function (formTemplateSet) {
                    this.publishFormTemplateConfirmAction(formTemplateSet);
                    deferred.resolve();
                }.bind(this), function () {
                    // On Error
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                    deferred.reject();
                }).finally(function () {
                    loadingBarHandler.hideLoadingBar();
                    $state.reload();
                });
            } else {
                configurationMediator.publishFormTemplatesByFilterUri(filterUri, excludedFormTemplateIds).then(function (formTemplateSet) {
                    this.publishFormTemplateConfirmAction(formTemplateSet);
                    deferred.resolve();
                }.bind(this), function () {
                    // On Error
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                    deferred.reject();
                }).finally(function () {
                    loadingBarHandler.hideLoadingBar();
                    $state.reload();
                });
            }
            return deferred.promise;
            };

        this.publishFormTemplateConfirmAction = formTemplateSet => {
            const config = {
                confirmActionButtonLabel: _.get(translations, 'formTemplateBrowser.createFormTemplateSet.confirmationConfirmActionButtonLabel'),
                summary: _.replace(_.get(translations, 'formTemplateBrowser.createFormTemplateSet.confirmation'), '{0}', formTemplateSet.id),
                title: _.get(translations, 'formTemplateBrowser.createFormTemplateSet.confirmationTitle')
            };
            modalUtil.showGenericConfirm(config);
        }

        this.createTestFormTemplateSet = function(){
            loadingBarHandler.showLoadingBar('formTemplateBrowser.createTestFormTemplateSet.loadingBar');
			return configurationMediator.createTestFormTemplateSet().then(function (formTemplateSet) {
				this.createTestFormTemplateSetConfirmAction(formTemplateSet);
			}.bind(this), function () {
				// On Error
				loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
			}).finally(function () {
				loadingBarHandler.hideLoadingBar();
				$state.reload();
			});
        };

        this.createTestFormTemplateSetConfirmAction = formTemplateSet => {
            const config = {
                confirmActionButtonLabel: _.get(translations, 'formTemplateBrowser.createTestFormTemplateSet.confirmationConfirmActionButtonLabel'),
                summary: _.replace(_.get(translations, 'formTemplateBrowser.createTestFormTemplateSet.confirmation'), '{0}', formTemplateSet.id),
                title: _.get(translations, 'formTemplateBrowser.createTestFormTemplateSet.confirmationTitle')
            };
            modalUtil.showGenericConfirm(config);
        }

        this.markFormTemplatesInProduction = function (selectedFormTemplates, filterUri, excludedFormTemplates) {
            let selectedFormTemplateIds = [],
                excludedFormTemplateIds = [],
                deferred = $q.defer();

            _.each(selectedFormTemplates, function (selectedFormTemplate) {
                selectedFormTemplateIds.push(selectedFormTemplate.id);
            });

            _.each(excludedFormTemplates, function (excludedFormTemplate) {
                excludedFormTemplateIds.push(excludedFormTemplate.id);
            });

            function handleClose() {
                loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.markInProduction.loadingBar'));
                if (!_.isEmpty(selectedFormTemplateIds)) {
                    configurationMediator.markFormTemplatesInProduction(selectedFormTemplateIds).then(function (result) {
                        if (result) {
                            loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                            modalUtil.openFormReferencesModal('formReferencesMarkInProductionInvalid', result);
                        } else {
                            loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.markInProduction.successMessage'));
                        }
                        deferred.resolve();
                    }, function () {
                        // On Error
                        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                        deferred.reject();
                    });
                } else {
                    configurationMediator.markFormTemplatesInProductionByFilterUri(filterUri, excludedFormTemplateIds).then(function (result) {
                        if (result) {
                            loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                            modalUtil.openFormReferencesModal('formReferencesMarkInProductionInvalid', result);
                        } else {
                            loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'formTemplateBrowser.markInProduction.successMessage'));
                        }
                        deferred.resolve();
                    }, function () {
                        // On Error
                        loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                        deferred.reject();
                    });
                }
            }

            modalUtil.showConfirmationModal(
                /*submissionId*/null,
                /*quoteId*/null,
                /*notificationName*/null,
                'formTemplateBrowser.markInProduction',
                /*logAction*/null,
                /*hideLoadingBar*/true,
                handleClose);
            return deferred.promise;
        };

        this.backup = function (sectionName, backupName, loadingBarMsg, successMsg) {
            loadingBarHandler.showNotificationLoadingBar(loadingBarMsg + ' ' + backupName);
            return configurationMediator.backup(sectionName).then(function (result) {
                const filename = backupName + '_' + moment().format('YYYYMMDDhhmmss') + '.dbinit';
                loadingBarHandler.concludeNotificationLoadingBar(successMsg + ' ' + backupName);
                fileExportUtil.saveAs(result, 'application/xml', filename);
            }, function () {
                // On Error
                loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
            });
        };

        this.saveProductTemplate = function (productTemplate) {
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'productTemplateEditorHeader.saveProductTemplate.loadingBar'));

            let promise;
            if (productTemplate.id) {
                promise = updateProductTemplate(productTemplate);
            } else {
                promise = createProductTemplate(productTemplate);
            }
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        };

        function updateProductTemplate(productTemplate) {
            return productTemplateEditorRepository.updateProductTemplate(productTemplate).then((productTemplate) => {
                const productTemplateToReturn = productTemplate,
                    quoteTemplateFile = productTemplateEditorModel.getQuoteTemplateFile(),
                    binderTemplateFile = productTemplateEditorModel.getBinderTemplateFile();
                // At least one of template should be selected
                if (quoteTemplateFile !== null || binderTemplateFile !== null) {
                    productTemplateEditorRepository.updateDocumentTemplates(productTemplate, quoteTemplateFile, binderTemplateFile).then(function () {
                        showConcludeNotificationLoadingBarAndDoLogging('productTemplateEditorHeader.saveProductTemplate.savingProductTemplateSuccessLoadingBar', uiPerformanceLoggerConstant.UPDATE_PRODUCT_TEMPLATE);
                        $state.reload();
                    });
                } else {
                    showConcludeNotificationLoadingBarAndDoLogging('productTemplateEditorHeader.saveProductTemplate.savingProductTemplateSuccessLoadingBar', uiPerformanceLoggerConstant.UPDATE_PRODUCT_TEMPLATE);
                }

                return productTemplateToReturn;
            }, function () {
                // On Error
                loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
            });
        }

        function showConcludeNotificationLoadingBarAndDoLogging(translationKey, uiPerfLoggingConstant) {
            loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, translationKey));
            $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerfLoggingConstant);
        }

        function createProductTemplate(productTemplate) {
            return productTemplateEditorRepository.createProductTemplate(productTemplate).then((productTemplate) => {
                const productTemplateToReturn = productTemplate,
                    quoteTemplateFile = productTemplateEditorModel.getQuoteTemplateFile(),
                    binderTemplateFile = productTemplateEditorModel.getBinderTemplateFile();
                if (quoteTemplateFile !== null || binderTemplateFile !== null) {
                    productTemplateEditorRepository.updateDocumentTemplates(productTemplate, quoteTemplateFile, binderTemplateFile).then(function () {
                        showConcludeNotificationLoadingBarAndDoLogging('productTemplateEditorHeader.saveProductTemplate.savingProductTemplateSuccessLoadingBar', uiPerformanceLoggerConstant.CREATE_PRODUCT_TEMPLATE);
                        $state.reload();
                    });
                } else {
                    showConcludeNotificationLoadingBarAndDoLogging('productTemplateEditorHeader.saveProductTemplate.savingProductTemplateSuccessLoadingBar', uiPerformanceLoggerConstant.CREATE_PRODUCT_TEMPLATE);
                }

                return productTemplateToReturn;
            }, function () {
                // On Error
                loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
            });
        }

        this.updatePermissions = function (permissions) {
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'permissionsEditorHeader.savePermissions.loadingBar'));
            if (permissions) {
                $rootScope.$broadcast(coreConstant.event.START_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPDATE_PERMISSION);
                let promise = configurationMediator.updatePermissions(permissions).then(() => {
                    loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'permissionsEditorHeader.savePermissions.savingPermissionsSuccessLoadingBar'));
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPDATE_PERMISSION, coreConstant.uiPeformanceLogger.SUCCESS);
                }, function () {
                    // On Error
                    loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
                    $rootScope.$broadcast(coreConstant.event.END_UI_PERFORMANCE_LOG, uiPerformanceLoggerConstant.UPDATE_PERMISSION, coreConstant.uiPeformanceLogger.FAIL);
                });
                $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                return promise;
            }
        };

        this.saveNotificationEmailTemplate = function (notificationEmailTemplate) {
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'manageEmailNotificationHeader.saveNotificationEmailTemplate.loadingBar'));

            let promise = notificationEmailTemplateRepository.saveNotificationEmailTemplate(notificationEmailTemplate).then(function (emailTemplate) {
                loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'manageEmailNotificationHeader.saveNotificationEmailTemplate.savingNotificationEmailTemplateSuccessLoadingBar'));
                return emailTemplate;
            }, function () {
                // On Error
                loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        };

        this.saveNotificationPopupTemplate = function (notificationPopupTemplate) {
            loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'managePopupNotificationHeader.saveNotificationPopupTemplate.loadingBar'));

            let promise = notificationPopupTemplateRepository.saveNotificationPopupTemplate(notificationPopupTemplate).then(function (popupTemplate) {
                loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'managePopupNotificationHeader.saveNotificationPopupTemplate.savingNotificationPopupTemplateSuccessLoadingBar'));
                return popupTemplate;
            }, function () {
                // On Error
                loadingBarHandler.hideNotificationLoadingBar(/*isHard*/true);
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
            return promise;
        };
    });
};

angular.module('ums.configuration')
    .service('configurationActionsUtil', ConfigurationActionsUtil);
